module.exports = __webpack_public_path__ + "static/media/shop-shop.beaefafa.jpg";